function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "e"
}, /*#__PURE__*/React.createElement("rect", {
  width: 23.077,
  height: 30,
  fill: "#009fda"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "g"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "f",
  clipPath: "url(#g)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-453.719 -362.463)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(457.258 362.463)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#e)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M472.258,374.579H469.95a.575.575,0,0,0-.577.576v2.308H468.22v-2.308a.575.575,0,0,0-.577-.576h-2.308v-1.155h2.308a.574.574,0,0,0,.577-.577V370.54h1.154v2.308a.575.575,0,0,0,.577.577h2.308Zm.577-2.308h-2.309v-2.308a.575.575,0,0,0-.577-.576h-2.307a.575.575,0,0,0-.577.576v2.308h-2.308a.577.577,0,0,0-.577.577v2.308a.577.577,0,0,0,.577.577h2.308v2.308a.577.577,0,0,0,.577.576h2.307a.577.577,0,0,0,.577-.576v-2.308h2.309a.575.575,0,0,0,.576-.577v-2.308a.575.575,0,0,0-.576-.577m-4.039,8.653A6.923,6.923,0,1,1,475.721,374a6.931,6.931,0,0,1-6.924,6.922m0-15A8.077,8.077,0,1,0,476.873,374a8.077,8.077,0,0,0-8.076-8.078m5.024,19.479c-1.354,1.747-2.713,3.268-3.733,4.347-.549.583-1,1.036-1.292,1.33-.3-.294-.743-.747-1.292-1.33-3.069-3.215-9.145-10.511-9.092-15.749a10.384,10.384,0,1,1,20.769,0c.023,3.474-2.639,7.915-5.359,11.4m-5.025-22.94A11.536,11.536,0,0,0,457.258,374c.021,4.025,2.84,8.527,5.6,12.109a60.517,60.517,0,0,0,5.54,6.195.577.577,0,0,0,.793,0,60.63,60.63,0,0,0,5.541-6.195c2.762-3.582,5.58-8.083,5.6-12.109A11.537,11.537,0,0,0,468.8,362.463",
  transform: "translate(-457.258 -362.463)",
  fill: "#009fda"
})))));

var SvgFindAPhysio30Px = function SvgFindAPhysio30Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFindAPhysio30Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FIND_A_PHYSIO_30px.00696e26.svg";
export { ForwardRef as ReactComponent };